/**
 * 已测算态下的 2 张转化卡：完整报告 / 分享图
 *
 * 设计原则：
 *  - 卡片视觉一致（同样的圆角、阴影、间距）
 *  - 主行动统一为"了解→点击→跳转"两步
 *  - 公益感 > 营销感（强调"对学弟学妹有用"而不是"加入我们"）
 *
 * 注：「回填录取结果」邀请已抽到独立的 <BackfillPledge>（紧贴预测结果展示）。
 */
import { Link } from 'react-router-dom'
import type { CalcResult } from '@/domain/types'
import { track } from '@/lib/track'

export function ConversionCards({ result }: { result: CalcResult }) {
  const score = result.input.score
  const year = result.input.policy.year
  const intent = result.input.intentSchool ?? ''
  const qs = new URLSearchParams({ score: String(score), year: String(year) })
  if (intent) qs.set('intent', intent)

  return (
    <div className="space-y-3">
      {/* 卡 1：完整报告 */}
      <Link
        to={`/report?${qs.toString()}`}
        onClick={() => track('drill_click', { target: 'open_report', from: 'conversion_card', score, intent })}
        className="block card hover:shadow-md transition active:scale-[0.99]"
      >
        <div className="flex items-start gap-3">
          <div className="w-12 h-12 rounded-xl bg-brand-100 flex items-center justify-center text-2xl shrink-0">
            📄
          </div>
          <div className="flex-1">
            <div className="text-h3 text-ink-900 mb-1">查看完整报告</div>
            <p className="text-ink-600 text-sm leading-relaxed">
              含 5 校详细介绍、6 项专业指标、三种情境推演、算法说明，
              可下载 PDF 留档或打印。
            </p>
          </div>
          <span className="text-brand-700 shrink-0">→</span>
        </div>
      </Link>

      {/* 卡 2：分享图 */}
      <Link
        to={`/share?${qs.toString()}`}
        onClick={() => track('drill_click', { target: 'open_share', from: 'conversion_card', score, intent })}
        className="block card hover:shadow-md transition active:scale-[0.99]"
      >
        <div className="flex items-start gap-3">
          <div className="w-12 h-12 rounded-xl bg-amber-100 flex items-center justify-center text-2xl shrink-0">
            🖼️
          </div>
          <div className="flex-1">
            <div className="text-h3 text-ink-900 mb-1">生成分享图</div>
            <p className="text-ink-600 text-sm leading-relaxed">
              一键生成精美图片，可发家长群讨论。
              分数默认模糊处理，保护隐私。
            </p>
          </div>
          <span className="text-amber-700 shrink-0">→</span>
        </div>
      </Link>

    </div>
  )
}
